import {Component, OnInit, Input, Output, ViewChild, EventEmitter, AfterViewInit} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoAppointmentKindForCombi} from "./models/DtoAppointmentKindForCombi";
import {DtoAppointmentKindCombination} from "./models/DtoAppointmentKindCombination";

@Component({
    selector: 'appointmentkind-select-combi',
    template: require('./appointmentkind-select-combi.component.html'),
    styles: [require('./appointmentkind-select-combi.component.css')]
})
@AutoUnsubscribe()

export class AppointmentkindSelectCombiComponent implements OnInit, AfterViewInit {
    @Input() dialog: DialogRef;
    @Input() allAppointmentKinds: DtoAppointmentKindForCombi[];
    @Input() chosenAppointmentKinds: DtoAppointmentKindCombination[];
    @Output() combiSaved = new EventEmitter<DtoAppointmentKindCombination>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'duration',
            label: 'Duur',
            type: 'number',
            width: '80px'
        },
        {
            key: 'appointmentLabelDisplayName',
            color: 'appointmentLabelColor',
            label: 'Kleur',
            type: 'color',
            width: '150px'
        }
    ];

    ngOnInit() {

    }

    ngAfterViewInit() {
        let toShow: DtoAppointmentKindForCombi[] = [];
        for (let i = 0; i < this.allAppointmentKinds.length; i++) {
            if (
                !this.chosenAppointmentKinds.find(
                    x => x.appointmentKindId1 == this.allAppointmentKinds[i].id
                )
            ) {
                toShow.push(this.allAppointmentKinds[i]);
            }
        }
        setTimeout(() => {
            this.grid.showData(toShow);
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            let newIndex = 1;
            if (this.chosenAppointmentKinds.length > 0)
                newIndex = Math.max.apply(Math, this.chosenAppointmentKinds.map(function (o) {
                    return o.index;
                })) + 1;
            let combi = this.allAppointmentKinds.find(x => x.id == this.grid.getSelectedId());
            this.combiSaved.emit({
                id: 0,
                appointmentKindId1: combi.id,
                extension: combi.extension,
                duration: combi.duration,
                description: combi.description,
                index: newIndex
            });
            this.closeWindow(true);
        }
    }

    rowdoubleClicked(event) {
        this.btnSaveClicked(null);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/appointmentkind-select-combi.component.ts